module.exports = __webpack_public_path__ + "static/media/warning.c01981b8.svg";